import { Calendar } from '@phosphor-icons/react';
import Button from '../../../components/button/button';
import Icon from '../../../components/icon/icon';
import React from 'react'

const Banner = () => {
  return (
    <div className='p-6 flex md:flex-row flex-col gap-4 bg-grey-5 rounded-xl items-center w-full md:justify-between'>
      <div className='flex md:gap-4 items-center justify-between flex-row gap-3'> 
        <Icon 
          type='square'><Calendar
            size={32}
            color='#101010'
          /></Icon>
        <div className='flex gap-6'> 
          <div className='flex flex-col gap-2'> 
            <div className='heading-16'>Looking to organize an event?</div>
            <div className='text-14 md:visible hidden'>We offer the lowest fees</div>
          </div>
        </div>
      </div>
      <a href='/landing' 
        className='w-[270px]'>
        <Button
          type='tertiary'
          className='w-full'
        >List your event</Button>
      </a>
      
    </div>
  )
}

export default Banner
